import React from "react";
import { IconButton } from "@mui/material";
import { ModeEditOutlineTwoTone } from "@mui/icons-material";
import AppTable from "components/Shared/AppTable";

const DAYS_OF_WEEK = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

const RouteVehicleDepartureList = ({ departures, isLoading, onEdit }) => {
    const columns = [
        {
            name: "#",
            selector: (row, index) => index + 1,
            cell: (row, index) => index + 1,
            width: "60px",
        },
        {
            name: "Driver",
            selector: (row) => row?.driver?.name,
            cell: (row) => row?.driver?.name ?? "N/A",
            sortable: true,
            minWidth: "150px",
        },
        {
            name: "Vehicle",
            selector: (row) => row?.vehicle?.vehicle_id,
            cell: (row) => row?.vehicle?.vehicle_id ?? "N/A",
            sortable: true,
            minWidth: "120px",
        },
        ...DAYS_OF_WEEK.map(day => ({
            name: day.substring(0, 3),
            selector: (row) => {
                const schedule = row?.schedules?.find(s => s.day === day);
                return schedule?.departureTime || "";
            },
            cell: (row) => {
                const schedule = row?.schedules?.find(s => s.day === day);
                return (
                    <span style={{ fontSize: '0.875rem' }}>
                        {schedule?.departureTime || "-"}
                    </span>
                );
            },
            sortable: false,
            minWidth: "90px",
        })),
        {
            name: "Actions",
            cell: (row) => (
                <IconButton
                    size="small"
                    onClick={() => onEdit(row)}
                    aria-label="Edit Departure"
                >
                    <ModeEditOutlineTwoTone />
                </IconButton>
            ),
            ignoreRowClick: true,
            right: true,
            width: "80px",
        },
    ];

    return (
        <AppTable
            columns={columns}
            data={departures}
            progressPending={isLoading}
            noDataComponent={
                <div className="p-4 text-gray-500">
                    No departures available for this route.
                </div>
            }
            dense
            pagination={false}
        />
    );
};

export default RouteVehicleDepartureList;